import { SVGProps } from 'react';
import { tokens } from '../../core/theme';

type DevicesIconProps = SVGProps<SVGSVGElement> & { color?: string };

export const DevicesIcon = ({
  width = 25,
  height = 25,
  color = tokens.colors.brand.red.DEFAULT,
  ...props
}: DevicesIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.0046 18.0075H13.0054"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.0079 12.0052V5.0023C19.0079 3.89727 18.1121 3.00146 17.0071 3.00146H6.55876C5.45373 3.00146 4.55792 3.89727 4.55792 5.0023V10.0044"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0083 20.0082H17.0071C16.4546 20.0082 16.0067 19.5603 16.0067 19.0078V13.0053C16.0067 12.4528 16.4546 12.0049 17.0071 12.0049H20.0083C20.5608 12.0049 21.0087 12.4528 21.0087 13.0053V19.0078C21.0087 19.5603 20.5608 20.0082 20.0083 20.0082Z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.0067 15.0061H11.0046"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="3.00122"
        y="10.0044"
        width="8.00333"
        height="11.0046"
        rx="1.5"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
